import { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";

const VerificationDetailsContext = createContext();
VerificationDetailsContext.displayName = "verificationForm";

export const useVerificationDetails = () =>
  useContext(VerificationDetailsContext);

export const VerificationDetailsProvider = ({
  children,
  initialState,
  reducer,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <VerificationDetailsContext.Provider value={[state, dispatch]}>
      {children}
    </VerificationDetailsContext.Provider>
  );
};

VerificationDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    verificationDetails: PropTypes.object.isRequired,
  }),
  reducer: PropTypes.func.isRequired,
};
